<template>
  <div>
    <output-dialog-split
      :confirmed="request.confirmed"
      :operation="operation"
      :pages="pages"
      @confirm="confirm"
      :needNotFix="true"
      @recordHistory="recordHistory"
      @sjlDownload="sjlDownload"
      filename="海外請求書.pdf"
      orientation="portrait"
      ref="printDlg"
      title="海外請求書"
      confirmAuth="SHARP_OVERSEAS_ISSUE_CONFIRM"
    >
      <template slot-scope="{ page }">
        <overseas-pdf :request="page" />
      </template>
    </output-dialog-split>
  </div>
</template>
<script>
import OverseasPdf from './OverseasPdf.vue'
export default {
  components: { OverseasPdf },
  data() {
    return {
      pages: [],
      operation: null,
      request: {},
    }
  },
  methods: {
    popup(data, operation) {
      this.pages = []
      this.operation = operation
      this.request = data
      this.load()
    },
    load() {
      this.$http.get(`overseas-requests/${this.request.id}`).then((res) => {
        let charges = res.data.charges
        let maxChargeRows = 13
        for (
          let page = 1;
          page <= Math.ceil((charges.length + 1) / maxChargeRows);
          page++
        ) {
          this.pages.push({
            ...res.data,
            isLast: page === Math.ceil((charges.length + 1) / maxChargeRows),
            pageNo:
              page + '/' + Math.ceil((charges.length + 1) / maxChargeRows),
            chargesTotal: charges
              .map((c) => c.totalPrice)
              .reduce((c, t) => {
                return (t += c)
              }, 0),
            charges: charges.slice(
              (page - 1) * maxChargeRows,
              page * maxChargeRows >= charges.length
                ? charges.length
                : page * maxChargeRows
            ),
          })
        }

        // this.pages.push({ ...res.data })
        this.request = res.data
        this.$refs.printDlg.show = true
      })
    },
    fix() {
      this.$refs.fixDialog.popup(this.request)
    },
    refresh() {
      this.pages = []
      this.load()
    },
    confirm() {
      this.$http
        .put(`overseas-requests/${this.request.id}/confirmed`)
        .then(() => {
          this.$message('', 'SUCCESS')
          this.refresh()
          this.$emit('reload')
        })
    },
    sjlDownload() {
      this.$http
        .put(`overseas-requests/${this.request.id}/sjl-download`)
        .then(() => {
          this.$message('', 'SUCCESS')
          this.refresh()
          this.$emit('reload')
        })
    },
    recordHistory() {
      console.log('record history')
      this.$http
        .post(
          `overseas-requests/histories/${this.request.id}?type=${this.operation}`
        )
        .then(() => {
          this.$message('', 'SUCCESS')
          this.$refs.printDlg.show = false
          this.$emit('reload')
        })
        .catch(() => {
          this.$message('', 'FAILED')
        })
    },
  },
}
</script>